import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatusDiscovery = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	fill: "currentcolor",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M10.5 15.06v-3.81a.75.75 0 0 1 .75-.75h3.81z" }), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M13 1a2 2 0 0 1 2 2v6h-4.75C9.56 9 9 9.56 9 10.25V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM4 9h3V7.5H4zm0-5v1.5h7V4z",
		clipRule: "evenodd"
	})]
});
export default SvgStatusDiscovery;
